import { useEffect } from "react";
import { useBranding } from "../../branding";
import { ScrollTrigger, useGSAP } from "../../motion";
import { useDocumentTitle } from "../../shell";
import styles from "./Vitrine.module.css";
import { VitrineCta } from "./VitrineCta";
import { VitrineEntete } from "./VitrineEntete";
import { VitrineEspaces } from "./VitrineEspaces";
import { VitrineEtapes } from "./VitrineEtapes";
import { VitrineHero } from "./VitrineHero";
import { VitrineInvariant } from "./VitrineInvariant";
import { VitrinePied } from "./VitrinePied";
import { VitrineReperes } from "./VitrineReperes";

/**
 * La page d'accueil publique. Elle n'a pas de coquille : son en-tête et son
 * pied sont les siens, et son héros est sombre là où l'application reste
 * claire.
 */
export function VitrinePage() {
  const { product_short, product_name } = useBranding();
  useDocumentTitle(`${product_short} · ${product_name}`);

  // Le défilement par écrans est une règle de `<html>` (base.css) : on la pose
  // le temps de la page, et on la retire en partant pour que l'application
  // défile normalement.
  useEffect(() => {
    document.documentElement.dataset.vitrine = "";
    return () => {
      delete document.documentElement.dataset.vitrine;
    };
  }, []);

  // Inter variable change la hauteur des lignes à son arrivée : les positions
  // de déclenchement calculées avant sont fausses de quelques dizaines de
  // pixels. On les recalcule une fois les polices prêtes.
  useGSAP(() => {
    void document.fonts.ready.then(() => ScrollTrigger.refresh());
  });

  return (
    <div className={styles.page}>
      <a className={styles.evitement} href="#contenu">
        Aller au contenu
      </a>
      <VitrineEntete />
      <main id="contenu">
        <VitrineHero />
        <VitrineEtapes />
        <VitrineEspaces />
        <VitrineInvariant />
        <VitrineCta />
      </main>
      <VitrinePied />
      <VitrineReperes />
    </div>
  );
}
